import { PaginatedHolidaysQueryVariables } from "@/graphql/__generated__/graphql";
import DateRangeFilter from "../../Shared/DateRangeFilter";
import { format } from "date-fns";

interface Props {
  displayAmount: number;
  handleSubmitClick: (_variables?: PaginatedHolidaysQueryVariables) => void;
}

/**
 * HolidaysDateRange component for filtering holidays by date range
 * @param props Component properties
 * @returns JSX element
 */
function HolidaysDateRange({ displayAmount, handleSubmitClick }: Props) {
  const holidayDateConfig = {
    paginationStateKey: "paginatedHolidays" as keyof PaginationState,
    dateFieldName: "date",
    filterTextKey: "components:filters.holidays.date",
    buildQueryVariables: (
      displayAmount: number,
      filters: any,
      dateRange: { gte: Date | null; lte: Date | null },
      sort?: any
    ): PaginatedHolidaysQueryVariables => ({
      first: displayAmount,
      filters: {
        date: (dateRange.gte === null && dateRange.lte === null) ? null : {
          gte: dateRange.gte ? format(dateRange.gte, "yyyy-MM-dd") + "T00:00:00+00:00" : null,
          lte: dateRange.lte ? format(dateRange.lte, "yyyy-MM-dd") + "T23:59:59+00:00" : null,
        },
        provinces: filters.provinces || null,
      },
      sort: sort
    }),
    extractFilters: (paginationState: any) => ({
      date: paginationState.filters?.date,
      provinces: paginationState.filters?.provinces,
    })
  };

  return (
    <DateRangeFilter
      displayAmount={displayAmount}
      handleSubmitClick={handleSubmitClick}
      config={holidayDateConfig}
    />
  );
}

export default HolidaysDateRange;
